import script from "./AttendeePage.vue?vue&type=script&setup=true&lang=js"
export * from "./AttendeePage.vue?vue&type=script&setup=true&lang=js"

import "./AttendeePage.vue?vue&type=style&index=0&id=08688d4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08688d4a"]])

export default __exports__